import { getLocale } from '../i18n';

// fr is the McDonald's Canada audience, so Canadian French dates.
const DATE_LOCALES = { en: 'en-GB', fr: 'fr-CA' } as const;

/** "3 December 2026" / "3 décembre 2026", in the active language. */
export const formatLongDate = (date: Date | string): string =>
  new Date(date).toLocaleDateString(DATE_LOCALES[getLocale()], {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  });
